import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

const FooterAr = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300" dir="rtl">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/ar" className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_solar-epc-oman/artifacts/746jwpae_ECOSUN%20%281%29.svg" 
                alt="شعار إيكوصن للطاقة المتجددة" 
                className="h-16 w-16 rounded-full"
                width="64"
                height="64"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="font-semibold text-white mb-2">إيكوصن للطاقة المتجددة</p>
            <p className="text-sm mb-4">
              شركة رائدة في مجال الطاقة الشمسية في عُمان، متخصصة في أنظمة الطاقة الشمسية المتصلة بالشبكة وأنظمة تخزين الطاقة بالبطاريات وخدمات التشغيل والصيانة.
            </p>
            <div className="flex space-x-3 space-x-reverse">
              <a href="https://www.linkedin.com/company/ecosunrenewables" target="_blank" rel="noopener noreferrer" aria-label="تابعنا على لينكدإن" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="https://www.facebook.com/ecosunrenewables" target="_blank" rel="noopener noreferrer" aria-label="تابعنا على فيسبوك" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/ecosunrenewables" target="_blank" rel="noopener noreferrer" aria-label="تابعنا على إنستغرام" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">روابط سريعة</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ar" className="hover:text-emerald-400 transition-colors">الرئيسية</Link></li>
              <li><Link to="/ar/services" className="hover:text-emerald-400 transition-colors">الخدمات</Link></li>
              <li><Link to="/ar/blog" className="hover:text-emerald-400 transition-colors">المدونة</Link></li>
              <li><Link to="/ar/calculator" className="hover:text-emerald-400 transition-colors">حاسبة الطاقة الشمسية</Link></li>
              <li><Link to="/ar/contact" className="hover:text-emerald-400 transition-colors">اتصل بنا</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">خدماتنا</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ar/services" className="hover:text-emerald-400 transition-colors">أنظمة الطاقة الشمسية المتصلة بالشبكة</Link></li>
              <li><Link to="/ar/services" className="hover:text-emerald-400 transition-colors">أنظمة تخزين الطاقة بالبطاريات</Link></li>
              <li><Link to="/ar/services" className="hover:text-emerald-400 transition-colors">الاستشارات الشمسية</Link></li>
              <li><Link to="/ar/services" className="hover:text-emerald-400 transition-colors">خدمات التشغيل والصيانة</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">تواصل معنا</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2 space-x-reverse">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-emerald-400" />
                <span>مسقط، سلطنة عُمان</span>
              </li>
              <li className="flex items-center space-x-2 space-x-reverse">
                <Phone className="w-4 h-4 flex-shrink-0 text-emerald-400" />
                <a href="tel:+96891305426" className="hover:text-emerald-400 transition-colors" dir="ltr">+968 91305426</a>
              </li>
              <li className="flex items-center space-x-2 space-x-reverse">
                <Mail className="w-4 h-4 flex-shrink-0 text-emerald-400" />
                <a href="mailto:sales@ecosunrenewables.com" className="hover:text-emerald-400 transition-colors" dir="ltr">sales@ecosunrenewables.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 pb-8 border-t border-gray-800">
          <p className="text-sm text-gray-400 text-center">
            <strong className="text-gray-300">مناطق الخدمة:</strong> مسقط • صحار • صلالة • نزوى • صور • عبري • بركاء • الرستاق • جميع أنحاء عُمان
          </p>
        </div>

        <div className="pt-6 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; {currentYear} إيكوصن للطاقة المتجددة. جميع الحقوق محفوظة. | شركة طاقة شمسية في عُمان</p>
            <div className="flex space-x-6 space-x-reverse mt-4 md:mt-0">
              <Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors">سياسة الخصوصية</Link>
              <Link to="/terms" className="hover:text-emerald-400 transition-colors">شروط الخدمة</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAr;
